import React from 'react';
import '../template-file-css/document-file-template.css';


export const OTP_IntakeAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='OTP_IntakeAssessment' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Persons Present:</span>
                            <input type='text' id='txtPersonsPresent' name='txtPersonsPresent' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Referral Source:</span>
                            <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Father's Name:</span>
                            <input type='text' id='txtFathersName' name='txtFathersName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Father's DOB:</span>
                            <input type='date' id='txtFathersDob' name='txtFathersDob' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Mother's Name:</span>
                            <input type='text' id='txtMothersName' name='txtMothersName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Mother's DOB:</span>
                            <input type='date' id='txtMothersDob' name='txtMothersDob' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Guardian/Caretaker:</span>
                            <input type='text' id='txtGuardian' name='txtGuardian' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Informant's Name & Relationship to Consumer</span>
                            <input type='text' id='txtInformant' name='txtInformant' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Informant's Telephone #:</span>
                            <input type='text' id='txtGuardianPhone' name='txtGuardianPhone' className='add-only' />
                        </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Reason for Assessment/Presenting Problems:</span>
                    <span className='small'>(Specific statement of mental health symptoms; frequency and duration
                        of conduct and behaviors, behaviors and concerns that would justify a referral for CORE or
                        Intensive Services)</span>
                    <textarea id='txtAssessmentReason' name='txtAssessmentReason' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>History of Presenting Problem</span>
                    <textarea id='txtProblemHistory' name='txtProblemHistory' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Household Composition</h3></p>


                <table>
                    <tr>
                        <td className='w-187'><span className='eleHeader'>Name</span></td>
                        <td className='w-187'><span className='eleHeader'>Relationship</span></td>
                        <td className='w-187'><span className='eleHeader'>DOB or Age</span></td>
                        <td className='w-187'><span className='eleHeader'>Occupation</span></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='text' id='txtHouseholdName1' name='txtHouseholdName1' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdRelationship1' name='txtHouseholdRelationship1' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdDob1' name='txtHouseholdDob1' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdOccupation1' name='txtHouseholdOccupation1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='text' id='txtHouseholdName2' name='txtHouseholdName2' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdRelationship2' name='txtHouseholdRelationship2' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdDob2' name='txtHouseholdDob2' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdOccupation2' name='txtHouseholdOccupation2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='text' id='txtHouseholdName3' name='txtHouseholdName3' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdRelationship3' name='txtHouseholdRelationship3' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdDob3' name='txtHouseholdDob3' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdOccupation3' name='txtHouseholdOccupation3' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='text' id='txtHouseholdName4' name='txtHouseholdName4' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdRelationship4' name='txtHouseholdRelationship4' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdDob4' name='txtHouseholdDob4' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdOccupation4' name='txtHouseholdOccupation4' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='text' id='txtHouseholdName5' name='txtHouseholdName5' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdRelationship5' name='txtHouseholdRelationship5' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdDob5' name='txtHouseholdDob5' className='add-only' /></td>
                        <td className='w-187'><input type='text' id='txtHouseholdOccupation5' name='txtHouseholdOccupation5' className='add-only' /></td>
                    </tr>

                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Living Situation</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>


                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Home' name='cbLiving_Home' className='add-only' value='HomeFamily' /> Home w/family</td>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Indep' name='cbLiving_Indep' className='add-only' value='IndependentLiving' /> Independent Living</td>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Group' name='cbLiving_Group' className='add-only' value='GroupHomeFosterHome' /> Group Home/Foster Home</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Homeless' name='cbLiving_Homeless' className='add-only' value='Homeless' /> Homeless</td>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Adequate' name='cbLiving_Adequate' className='add-only' value='AdequateHousing' /> Adequate Housing</td>
                        <td className='w-250'><input type='checkbox' id='cbLiving_SafetyRisk' name='cbLiving_SafetyRisk' className='add-only' value='SafetyRisksHazardous' /> Safety Risks/Hazardous</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbLiving_Overcrowded' name='cbLiving_Overcrowded' className='add-only' value='Overcrowded' /> Overcrowded</td>
                        <td className='w-250'><input type='checkbox' id='cbLiving_HomelessRisk' name='cbLiving_HomelessRisk' className='add-only' value='RiskHomelessness' /> Risk of Homelessness</td>
                    </tr>

                </table>


                <p className='w-750'><h3>Medical Screening/Health History</h3></p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Medical Exam:</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbMedExam' name='cbMedExam' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-150'>
                            Date:<br />
                            <input type='date' id='txtMedExamDate' name='txtMedExamDate' className='add-only' />
                        </td>
                        <td className='w-450'>
                            PCP Name and Location:<br />
                            <input type='text' id='txtMedExamPCPLoc' name='txtMedExamPCPLoc' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Dental Exam:</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbDentalExam' name='cbDentalExam' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-150'>
                            Date:<br />
                            <input type='date' id='txtDentalExamDate' name='txtDentalExamDate' className='add-only' />
                        </td>
                        <td className='w-450'>
                            DMD Name and Location:<br />
                            <input type='text' id='txtDentalExamDMDLoc' name='txtDentalExamDMDLoc' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Psychological Evaluation:</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'><input type='checkbox' id='cbPsychEval' name='cbPsychEval' className='add-only' value='NoneReported' /> None Reported</td>
                        <td className='w-150'>
                            Date:<br />
                            <input type='date' id='txtPsychEvalDate' name='txtPsychEvalDate' className='add-only' />
                        </td>
                        <td className='w-450'>
                            Provider Name and Location:<br />
                            <input type='text' id='txtPsychEvalLoc' name='txtPsychEvalLoc' className='add-only' />
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Medical Complaints:</span>
                    <input type='checkbox' id='cbMedComplaints' name='cbMedComplaints' className='add-only' value='NoneReported' /> None Reported<br />
                    Current Complaints:<br />
                    <textarea id='txtMedComplaintsCurrent' name='txtMedComplaintsCurrent' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Current Medications:</span>
                    <input type='checkbox' id='cbCurrMeds' name='cbCurrMeds' className='add-only' value='NoneReported' /> None Reported<br />
                    Current Complaints: (include dosage, prescribing doctor, purpose, and duration)<br />
                    <textarea id='txtCurrMedsCurrent' name='txtCurrMedsCurrent' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Past Medications:</span>
                    <input type='checkbox' id='cbPastMeds' name='cbPastMeds' className='add-only' value='NoneReported' /> None Reported<br />
                    Past Medications: (include dosage, prescribing doctor, purpose, and duration)<br />
                    <textarea id='txtPastMedsCurrent' name='txtPastMedsCurrent' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Mental Health/Psychiatric History:</span>
                    <span className='small'>(include history of counseling, dates, and reason)</span>
                    <input type='checkbox' id='cbMentalHealth' name='cbMentalHealth' className='add-only' value='NoneReported' /> None Reported<br />
                    Name of provider, duration of treatment, diagnosis, date, issues:<br />
                    <textarea id='txtMentalHealthCurrent' name='txtMentalHealthCurrent' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Eating Patterns:</span>
                    <span className='small'>(eating disorders, appetite)</span>
                    <textarea id='txtEatingPatterns' name='txtEatingPatterns' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Sleeping Patterns:</span>
                    <span className='small'>(insomnia, oversleeping)</span>
                    <textarea id='txtSleepingPatterns' name='txtSleepingPatterns' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Exercise Patterns:</span></td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbExercise' name='cbExercise' className='add-only' value='NoneReported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Frequency and Type:<br />
                            <input type='text' id='txtExerciseFreqType' name='txtExerciseFreqType' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <h3>Allergies</h3>
                    <input type='checkbox' id='cbAllergies_None' name='cbAllergies_None' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medication:</span>
                    <textarea id='txtAllergies_Meds' name='txtAllergies_Meds' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Food:</span>
                    <textarea id='txtAllergies_Food' name='txtAllergies_Food' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Seasonal/Pets:</span>
                    <textarea id='txtAllergies_Seasonal' name='txtAllergies_Seasonal' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h3>Deficits</h3>
                    <span className='small'>(glasses, hearing aids, walker)</span>
                    <input type='checkbox' id='cbDeficits_None' name='cbDeficits_None' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Hearing:</span>
                    <textarea id='txtAllergies_Hearing' name='txtAllergies_Hearing' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Seeing:</span>
                    <textarea id='txtAllergies_Seeing' name='txtAllergies_Seeing' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Speech:</span>
                    <textarea id='txtAllergies_Speech' name='txtAllergies_Speech' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Immunization:</span>
                            <input type='radio' id='rbImmunization_Yes' name='rbImmunization' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbImmunization_No' name='rbImmunization' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Verified:</span>
                            <input type='radio' id='rbVerified_Yes' name='rbVerified' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbVerified_No' name='rbVerified' className='add-only' value='No' /> No
                        </td>
                    </tr>

                </table>


                <p className='w-750'><h3>Family History</h3></p>


                <p className='w-750'>
                    <span className='eleHeader'>Source of income, debt, financial issues:</span>
                    <textarea id='txtFamHistory_Debt' name='txtFamHistory_Debt' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems:</span>
                    <span className='small'>(Heart Disease, Lung Disease, Cancer, Strokes, Dementia, Diabetes, Asthma)</span>
                    <input type='checkbox' id='cbMedicalProblems' name='cbMedicalProblems' className='add-only' value='NoneReported' /> None Reported<br />
                    Specify person and problem:<br />
                    <textarea id='txtMedicalProblems' name='txtMedicalProblems' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse:</span>
                    <span className='small'>(Alcohol, Cocaine, Cannabis, Stimulants, Inhalants, Hallucinogens, Sedatives, Designer Drugs)</span>
                    <input type='checkbox' id='cbSA' name='cbSA' className='add-only' value='NoneReported' /> None Reported<br />
                    Specify person and problem:<br />
                    <textarea id='txtSA' name='txtSA' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Mental Illness:</span>
                    <span className='small'>(Depression, Schizophrenia, Bipolar disorder, Anxiety, ADD, ADHD, Learning Disorders,
                        School Behavior, Problems, Incarcerations, Gambling)</span>
                    <input type='checkbox' id='cbMentalIllness' name='cbMentalIllness' className='add-only' value='NoneReported' /> None Reported<br />
                    Specify person and problem:<br />
                    <textarea id='txtMentalIllness' name='txtMentalIllness' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family Dynamics:</span>
                    <span className='small'>(include history of relationships; history of guardians; how problems have been handled;
                        safety issues; domestic violence; custody and abuse)</span>
                    <textarea id='txtFamilyDynamics' name='txtFamilyDynamics' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past or current involvement with DFCS:</span>
                    <span className='small'>(include dates, reason, resolution)</span>
                    <textarea id='txtDfcs' name='txtDfcs' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past or current involvement with DJJ:</span>
                    <span className='small'>(include dates, reason, resolution)</span>
                    <textarea id='txtDJJ' name='txtDJJ' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Have there been any major family stressors during the past six months:</span>
                    <span className='small'>(family separation, financial, marital, health, moves, and/or death of significant other)</span>
                    <textarea id='txtFamilyStressors' name='txtFamilyStressors' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe behavior management techniques utilized with child:</span>
                    <span className='small'>(include the type of discipline and who is the primary disciplinarian, consumer reaction to discipline)</span>
                    <textarea id='txtBxMgmtTechs' name='txtBxMgmtTechs' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe consumer's personality as per informant:</span>
                    <span className='small'>(management of anger, problem solving/coping skills, impulsivity, peer relationships and self-esteem)</span>
                    <textarea id='txtConsumersPersonality' name='txtConsumersPersonality' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Did you discuss advance directives with consumer and guardian?:</span>
                    <input type='radio' id='rbAdvDirect_Yes' name='rbAdvDirect' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAdvDirect_No' name='rbAdvDirect' className='add-only' value='No' /> No <br />
                    Comments:<br />
                    <textarea id='txtAdvDirectComments' name='txtAdvDirectComments' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>General Appearance</h3></p>


                <p className='w-750'>
                    <span className='eleHeader'>Appearance and General Behavior:</span>
                    <textarea id='txtGenBx' name='txtGenBx' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Mood and Affect:</span>
                    <textarea id='txtGenMood' name='txtGenMood' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <h3>Psycho-Social</h3>
                    <span className='small'>(identify duration, intensity, frequency, dates, history, triggers, treatment)</span>
                </p>


                <p className='w-750'>
                    <h5>Suicidal Ideation</h5>
                    <input type='checkbox' id='cbSuicidalIdeation' name='cbSuicidalIdeation' className='add-only' value='NoneReported' /> None Reported
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtSuicidalIdeation_Past' name='txtSuicidalIdeation_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtSuicidalIdeation_Current' name='txtSuicidalIdeation_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Self-Mutilation/Cutting</h5>
                    <input type='checkbox' id='cbCutting' name='cbCutting' className='add-only' value='NoneReported' /> None Reported
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtCutting_Past' name='txtCutting_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtCutting_Current' name='txtCutting_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Homicidal Ideation</h5>
                    <input type='checkbox' id='cbHomicidalIdeation' name='cbHomicidalIdeation' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtHomicidalIdeation_Past' name='txtHomicidalIdeation_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtHomicidalIdeation_Current' name='txtHomicidalIdeation_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Delusions/Hallucinations</h5>
                    <input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtDelusions_Past' name='txtDelusions_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtDelusions_Current' name='txtDelusions_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>OCD Behaviors</h5>
                    <input type='checkbox' id='cbOcd' name='cbOcd' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtOcd_Past' name='txtOcd_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtOcd_Current' name='txtOcd_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>PTSD Symptoms</h5>
                    <input type='checkbox' id='cbPtsd' name='cbPtsd' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Specify:</span>
                    <textarea id='txtPtsd' name='txtPtsd' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Temper Tantrums/Rapid Mood Swings</h5>
                    <input type='checkbox' id='cbTantrums' name='cbTantrums' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Past:</span>
                    <textarea id='txtTantrums_Past' name='txtTantrums_Past' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current:</span>
                    <textarea id='txtTantrums_Current' name='txtTantrums_Current' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Aggressive Behavior</h5>
                    <input type='checkbox' id='cbAggressiveBx' name='cbAggressiveBx' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Specify:</span>
                    <textarea id='txtAggressiveBx' name='txtAggressiveBx' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Oppositional Behavior</h5>
                    <input type='checkbox' id='cbOppositionalBx' name='cbOppositionalBx' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Specify:</span>
                    <textarea id='txtOppositionalBx' name='txtOppositionalBx' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Sexualized Behavior</h5>
                    <input type='checkbox' id='cbSexBx' name='cbSexBx' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Sexual Promiscuity:</span>
                    <textarea id='txtSexBx_Promiscuity' name='txtSexBx_Promiscuity' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Prostitution:</span>
                    <textarea id='txtSexBx_Prostitution' name='txtSexBx_Prostitution' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>At-risk behaviors (unprotected sex):</span>
                    <textarea id='txtSexBx_AtRisk' name='txtSexBx_AtRisk' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>STD's and pregnancies:</span>
                    <textarea id='txtSexBx_Std' name='txtSexBx_Std' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Sexual Perpetrator</h5></p>

                <input type='checkbox' id='cbSexPerp' name='cbSexPerp' className='add-only' value='NoneReported' /> None Reported
                <p className='w-750'>
                    <span className='eleHeader'>Specify intensity, type, date of last incident, active charges,
                        history of treatment, current sexual supervision plan (DJJ):</span>
                    <textarea id='txtSexPerp_Specify' name='txtSexPerp_Specify' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>History of Abuse</h5>
                    <span className='small'>(explain nature of abuse, individuals involved, legal involvement, outcome,
                        current safety plan in the home, living conditions such as sharing of rooms with victim)</span>
                    <input type='checkbox' id='cbAbuse' name='cbAbuse' className='add-only' value='NoneReported' /> None Reported
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Sexual:</span>
                    <textarea id='txtAbuse_Sexual' name='txtAbuse_Sexual' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Physical:</span>
                    <textarea id='txtAbuse_Physical' name='txtAbuse_Physical' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Emotional:</span>
                    <textarea id='txtAbuse_Emotional' name='txtAbuse_Emotional' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Neglect:</span>
                    <textarea id='txtAbuse_Neglect' name='txtAbuse_Neglect' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Domestic Violence (witness):</span>
                    <textarea id='txtAbuse_Violence' name='txtAbuse_Violence' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Risky Behaviors</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskyBx_Shoplifting' name='cbRiskyBx_Shoplifting' className='add-only' value='Shoplifting' /> Shoplifting</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskyBx_Reckless' name='cbRiskyBx_Reckless' className='add-only' value='RecklessDriving' /> Reckless Driving</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskyBx_Gang' name='cbRiskyBx_Gang' className='add-only' value='GangInvolvement' /> Gang Involvement</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbRiskyBx_Drug' name='cbRiskyBx_Drug' className='add-only' value='DrugDealing' /> Drug Dealing</td>
                        <td className='w-250'><input type='checkbox' id='cbRiskyBx_Weapon' name='cbRiskyBx_Weapon' className='add-only' value='WeaponPossession' /> Weapon Possession</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRiskyBx_Other' name='cbRiskyBx_Other' className='add-only' value='No' /> Other: &nbsp;
                            <input type='text' id='txtRiskyBx_Other' name='txtRiskyBx_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Explain if Checked:</span>
                    <textarea id='txtRiskyBx_Explain' name='txtRiskyBx_Explain' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Developmental History</h3></p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Pregnancy</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreg_Planned' name='cbPreg_Planned' className='add-only' value='Planned' /> Planned
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreg_Unplanned' name='cbPreg_Unplanned' className='add-only' value='Unplanned' /> Unplanned
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPreg_Unknown' name='cbPreg_Unknown' className='add-only' value='Unknown' /> Unknown: &nbsp;
                            <input type='text' id='txtPreg_Unknown' name='txtPreg_Unknown' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delivery</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelivery_FullTerm' name='cbDelivery_FullTerm' className='add-only' value='FullTerm' /> Full Term
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbDelivery_Premature' name='cbDelivery_Premature' className='add-only' value='Premature' /> Premature, specify months: &nbsp;
                            <input type='text' id='txtDelivery_Premature' name='txtDelivery_Premature' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDelivery_Unknown' name='cbDelivery_Unknown' className='add-only' value='Unknown' /> Unknown: &nbsp;
                            <input type='text' id='txtDelivery_Unknown' name='txtDelivery_Unknown' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Delivery Complications:</span>
                    <textarea id='txtDeliveryComplications' name='txtDeliveryComplications' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Drug/Alcohol use during pregnancy:</span>
                    <input type='checkbox' id='cbDrugsPreg' name='cbDrugsPreg' className='add-only' value='NoneReported' /> None Reported
                    <textarea id='txtDrugsPreg' name='txtDrugsPreg' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h5>Developmental Milestones</h5>
                    <span className='small'>(walking, toilet training, speech development)</span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Average:</span>
                    <textarea id='txtDevMiles_Average' name='txtDevMiles_Average' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Slow:</span>
                    <textarea id='txtDevMiles_Slow' name='txtDevMiles_Slow' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Advanced:</span>
                    <textarea id='txtDevMiles_Advanced' name='txtDevMiles_Advanced' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Unknown:</span>
                    <textarea id='txtDevMiles_Unknown' name='txtDevMiles_Unknown' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Relationships/Social/Peer Interaction</h3></p>


                <p className='w-750'>
                    <span className='eleHeader'>Describe relationship with siblings:</span>
                    <textarea id='txtSiblingRelationship' name='txtSiblingRelationship' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe peer relationships:</span>
                    <span className='small'>(same sex and opposite-sex relationships)</span>
                    <textarea id='txtPeerRelationship' name='txtPeerRelationship' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Support System:</span>
                    <textarea id='txtSupportSystem' name='txtSupportSystem' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>School History</span>
                            <span className='small'>Include history of schools attended; any retentions/grade(s);
                                special services i.e. SST or Speech; general conduct, relationships with authority and peers;
                                academic goals and attendance trends; extra-curriculum activities; present school.</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSchoolHist_Mainstream' name='cbSchoolHist_Mainstream' className='add-only' value='MainstreamSchool' /> Mainstream School
                        </td>
                        <td className='w-170'>
                            <input type='checkbox' id='cbSchoolHist_Alt' name='cbSchoolHist_Alt' className='add-only' value='AlternativeSchool' /> Alternative School
                        </td>
                        <td className='w-240'>
                            <input type='checkbox' id='cbSchoolHist_PsychEd' name='cbSchoolHist_PsychEd' className='add-only' value='PsychoEducationalProgram' /> Psycho-educational Program
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSchoolHist_Out' name='cbSchoolHist_Out' className='add-only' value='OutSchool' /> Out of school
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <textarea id='txtSchoolHistory' name='txtSchoolHistory' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Substance Abuse Assessment</h3></p>


                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Age of 1st Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last Use</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Longest Period of Sobriety</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Alcohol</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age1' name='txtSaa_Age1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date1' name='txtSaa_Date1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq1' name='txtSaa_Freq1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober1' name='txtSaa_Sober1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Cannabis</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age2' name='txtSaa_Age2' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date2' name='txtSaa_Date2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq2' name='txtSaa_Freq2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober2' name='txtSaa_Sober2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Cocaine</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age3' name='txtSaa_Age3' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date3' name='txtSaa_Date3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq3' name='txtSaa_Freq3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober3' name='txtSaa_Sober3' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Stimulants</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age4' name='txtSaa_Age4' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date4' name='txtSaa_Date4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq4' name='txtSaa_Freq4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober4' name='txtSaa_Sober4' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Methamphetamine</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age5' name='txtSaa_Age5' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date5' name='txtSaa_Date5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq5' name='txtSaa_Freq5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober5' name='txtSaa_Sober5' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>LSD/PCP/Mushrooms</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age6' name='txtSaa_Age6' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date6' name='txtSaa_Date6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq6' name='txtSaa_Freq6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober6' name='txtSaa_Sober6' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Heroine/Methadone</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age7' name='txtSaa_Age7' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date7' name='txtSaa_Date7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq7' name='txtSaa_Freq7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober7' name='txtSaa_Sober7' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Steroids/Cough Syrup</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age8' name='txtSaa_Age8' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date8' name='txtSaa_Date8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq8' name='txtSaa_Freq8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober8' name='txtSaa_Sober8' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Tobacco</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age9' name='txtSaa_Age9' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date9' name='txtSaa_Date9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq9' name='txtSaa_Freq9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober9' name='txtSaa_Sober9' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-150'>Prescription Meds</td>
                        <td className='w-150'><input type='text' id='txtSaa_Age10' name='txtSaa_Age10' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtSaa_Date10' name='txtSaa_Date10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Freq10' name='txtSaa_Freq10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtSaa_Sober10' name='txtSaa_Sober10' className='add-only' /></td>
                    </tr>

                </table>


                <p className='w-750'><h3>Social Stressors</h3></p>


                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors1' name='cbSocialStressors1' className='add-only' value='Unknown' /> Problems with primary support group:<br />
                    <textarea id='txtSocialStressors1' name='txtSocialStressors1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors2' name='cbSocialStressors2' className='add-only' value='Unknown' /> Problems related to social environment:<br />
                    <textarea id='txtSocialStressors2' name='txtSocialStressors2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors3' name='cbSocialStressors3' className='add-only' value='Unknown' /> Educational problems:<br />
                    <textarea id='txtSocialStressors3' name='txtSocialStressors3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors4' name='cbSocialStressors4' className='add-only' value='Unknown' /> Occupational problems:<br />
                    <textarea id='txtSocialStressors4' name='txtSocialStressors4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors5' name='cbSocialStressors5' className='add-only' value='Unknown' /> Housing problems:<br />
                    <textarea id='txtSocialStressors5' name='txtSocialStressors5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors6' name='cbSocialStressors6' className='add-only' value='Unknown' /> Economic problems:<br />
                    <textarea id='txtSocialStressors6' name='txtSocialStressors6' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors7' name='cbSocialStressors7' className='add-only' value='Unknown' /> Problems with access to health care services:<br />
                    <textarea id='txtSocialStressors7' name='txtSocialStressors7' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbSocialStressors8' name='cbSocialStressors8' className='add-only' value='Unknown' /> Other psychosocial or environmental problems:<br />
                    <textarea id='txtSocialStressors8' name='txtSocialStressors8' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Child and Adolescent Functional Assessment Scale (CAFAS)</h3></p>


                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Scale Scores for Child's Functioning</span></td>
                        <td className='w-200'><span className='eleHeader'>8 Scales</span></td>
                        <td className='w-200'><span className='eleHeader'>Supporting Numbers</span></td>
                    </tr>

                    <tr>
                        <td className='w-350'>School/Work Performance</td>
                        <td className='w-200'><input type='text' id='txtCafas1_1' name='txtCafas1_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas1_2' name='txtCafas1_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Home Performance</td>
                        <td className='w-200'><input type='text' id='txtCafas2_1' name='txtCafas2_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas2_2' name='txtCafas2_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Community Performance</td>
                        <td className='w-200'><input type='text' id='txtCafas3_1' name='txtCafas3_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas3_2' name='txtCafas3_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Behavior Towards Others</td>
                        <td className='w-200'><input type='text' id='txtCafas4_1' name='txtCafas4_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas4_2' name='txtCafas4_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Moods/Emotions</td>
                        <td className='w-200'><input type='text' id='txtCafas5_1' name='txtCafas5_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas5_2' name='txtCafas5_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Self-Harmful Behavior</td>
                        <td className='w-200'><input type='text' id='txtCafas6_1' name='txtCafas6_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas6_2' name='txtCafas6_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Substance Use</td>
                        <td className='w-200'><input type='text' id='txtCafas7_1' name='txtCafas7_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas7_2' name='txtCafas7_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Thinking</td>
                        <td className='w-200'><input type='text' id='txtCafas8_1' name='txtCafas8_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas8_2' name='txtCafas8_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Total for child based on 8 Scales</td>
                        <td className='w-200'><input type='text' id='txtCafas9_1' name='txtCafas9_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas9_2' name='txtCafas9_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Caregiver Resources</span></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Material Needs</td>
                        <td className='w-200'><input type='text' id='txtCafas10_1' name='txtCafas10_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas10_2' name='txtCafas10_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-350'>Family/Social Support</td>
                        <td className='w-200'><input type='text' id='txtCafas11_1' name='txtCafas11_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtCafas11_2' name='txtCafas11_2' className='add-only' /></td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>CAFAS Narrative:</span>
                    <textarea id='txtCafasNarrative' name='txtCafasNarrative' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Problems/Needs (in order of most importance)</h3></p>


                <p className='w-750'>
                    <span className='eleHeader'>(1)</span>
                    <textarea id='txtNeeds1' name='txtNeeds1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(2)</span>
                    <textarea id='txtNeeds2' name='txtNeeds2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(3)</span>
                    <textarea id='txtNeeds3' name='txtNeeds3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(4)</span>
                    <textarea id='txtNeeds4' name='txtNeeds4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(5)</span>
                    <textarea id='txtNeeds5' name='txtNeeds5' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>Diagnostic Impression (DSM-IV)</h3></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS I:</span>
                            <input type='text' id='txtAxisI' name='txtAxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS II:</span>
                            <input type='text' id='txtAxisII' name='txtAxisII' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS III:</span>
                            <input type='text' id='txtAxisIII' name='txtAxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS IV:</span>
                            <input type='text' id='txtAxisIV' name='txtAxisIV' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS V - GAF (Current):</span>
                            <input type='text' id='txtAxisV' name='txtAxisV' className='add-only' />
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <h3>Problems/Needs (in order of most importance)</h3>
                    <span className='small'>(what services will On The Path provide to address problems
                        such as individual and family counseling, substance abuse counseling, community
                        resource linkage, academic assistance, psychiatric evaluation and medication maintenance, etc)</span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(1)</span>
                    <textarea id='txtRecommendations1' name='txtRecommendations1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(2)</span>
                    <textarea id='txtRecommendations2' name='txtRecommendations2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(3)</span>
                    <textarea id='txtRecommendations3' name='txtRecommendations3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(4)</span>
                    <textarea id='txtRecommendations4' name='txtRecommendations4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(5)</span>
                    <textarea id='txtRecommendations5' name='txtRecommendations5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(6)</span>
                    <textarea id='txtRecommendations6' name='txtRecommendations6' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(7)</span>
                    <textarea id='txtRecommendations7' name='txtRecommendations7' className='add-only'></textarea>
                </p>


                <p className='w-750'><h3>SNAP's</h3></p>


                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id='txtStrengths' name='txtStrengths' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Need:</span>
                    <textarea id='txtNeed' name='txtNeed' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id='txtAbilities' name='txtAbilities' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <h3>Consumer Goals/Expectations</h3>
                    <span className='small'>(in consumer's words and in order of importance)</span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal #1:</span>
                    <textarea id='txtConsumerGoal1' name='txtConsumerGoal1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal #2:</span>
                    <textarea id='txtConsumerGoal2' name='txtConsumerGoal2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal #3:</span>
                    <textarea id='txtConsumerGoal3' name='txtConsumerGoal3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Goal #4:</span>
                    <textarea id='txtConsumerGoal4' name='txtConsumerGoal4' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(When appropriate) IFI Admission Criteria (Y12 Provider Manual):</span>
                            <span className='small'>Check all that apply.</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_1' name='cbIfiAdmin_1' className='add-only' value='1' /></td>
                        <td className='w-730'>Youth has a diagnosis and duration of symptoms which classify that illness as SED
                            and/or diagnosed Substance Related Disorder.</td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_2' name='cbIfiAdmin_2' className='add-only' value='2' /></td>
                        <td className='w-730'>Youth has received documented services through other services modalities (such as CORE services) and/or
                            exhausted less intensive outpatient services. Treatment at a lower intensity has been attempted or given
                            serious consideration, but the risk factors for out-of-home placement are compelling.</td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_3' name='cbIfiAdmin_3' className='add-only' value='3' /></td>
                        <td className='w-730'>Youth and/or family have insufficient or severely limited resources or skills necessary to cope with
                            an immediate behavioral health crisis.</td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_4' name='cbIfiAdmin_4' className='add-only' value='4' /></td>
                        <td className='w-730'>Youth and/or family behavioral health issues are unmanageable in traditional outpatient treatment
                            and require intensive, coordinated clinical and supportive intervention.</td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_5' name='cbIfiAdmin_5' className='add-only' value='5' /></td>
                        <td className='w-730'>Because of behavioral health issues, the youth is at immediate risk of out-of-home placement or is
                            currently in out-of-home placement and reunification is imminent (therefore, intensive work needs to
                            begin with the youth and family regarding the youth's treatment goals.)</td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-20'><input type='checkbox' id='cbIfiAdmin_6' name='cbIfiAdmin_6' className='add-only' value='6' /></td>
                        <td className='w-730'>Because of behavioral health issues, the youth is at immediate risk of legal system intervention or
                            is currently involved with DJJ for behaviors/issues related to SED and/or the Substance-related disorder.</td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Interpretative Summary:</span>
                    <span className='small'>Include an analysis of the consumer's symptoms; consumer's perception of his/her need
                        for services, interventions that On The Path can offer and community-based needs; include psychological
                        recommendations, diagnosis information and criteria met, identify whether consumer meets CORE/IFI criteria,
                        and concluding statement</span>
                    <textarea id='txtInterpretativeSummary' name='txtInterpretativeSummary' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Diagnosis and Justification:</span>
                    <textarea id='txtDxJustify' name='txtDxJustify' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Planned Discharge:</span>
                            <input type='date' id='txtDxPlanDate' name='txtDxPlanDate' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>

                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Discharge Plan:</span>
                    <textarea id='txtDxPlan' name='txtDxPlan' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendation for step-down services:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_Csi' name='cbStepDownSvc_Csi' className='add-only' value='Csi' /> CSI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_IndivTherapy' name='cbStepDownSvc_IndivTherapy' className='add-only' value='IndividualTherapy' /> Individual Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_FamTherapy' name='cbStepDownSvc_FamTherapy' className='add-only' value='FamilyTherapy' /> Family Therapy
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_SaCounsel' name='cbStepDownSvc_SaCounsel' className='add-only' value='SubstanceAbuseCounseling' /> Substance Abuse Counseling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_MentorPgrm' name='cbStepDownSvc_MentorPgrm' className='add-only' value='MentorProgram' /> Mentor Program
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_MedMgmt' name='cbStepDownSvc_MedMgmt' className='add-only' value='SubstanceAbuseCounseling' /> Medication Management: <br />
                            <input type='text' id='txtStepDownSvc_MedMgmt' name='txtStepDownSvc_MedMgmt' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_PvtPhys' name='cbStepDownSvc_PvtPhys' className='add-only' value='MentorProgram' /> Private Physician: <br />
                            <input type='text' id='txtStepDownSvc_PvtPhys' name='txtStepDownSvc_PvtPhys' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStepDownSvc_Groups' name='cbStepDownSvc_Groups' className='add-only' value='MentorProgram' /> Groups (specify): <br />
                            <input type='text' id='txtStepDownSvc_Groups' name='txtStepDownSvc_Groups' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbStepDownSvc_Other' name='cbStepDownSvc_Other' className='add-only' value='SubstanceAbuseCounseling' /> Other (specify): &nbsp;
                            <input type='text' id='txtStepDownSvc_Other' name='txtStepDownSvc_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='signature w-275'></td>
                        <td className='signature w-275'></td>
                        <td className='signature w-130'></td>
                    </tr>

                    <tr>
                        <td className='small w-275'>Assessor's Signature</td>
                        <td className='small w-275'>Assessor's Printed Name & Credentials</td>
                        <td className='small w-130'>Date</td>
                    </tr>

                </table>



            </div>
        </form>

    )
}  
